export const DEMO_2_MALE_EMAIL = "demo.critus@avanti.ca";
export const DEMO_1_FEMALE_EMAIL = "amanda.harding@avanti.ca";
